import { AnchorHTMLAttributes, PropsWithChildren } from 'react';
import { link } from './externalLink.css';
import { RecipeVariants } from '@vanilla-extract/recipes';
import { typographyRecipe } from '../typography/typography.css';
import { bgColorsVars } from '@design-system/vars.css';
import { Typography } from '../typography/typography';

export const ExternalLink = ({
  label,
  textVariant,
  textSize,
  textColor,
  fontWeight,
  ...p
}: PropsWithChildren<AnchorHTMLAttributes<HTMLAnchorElement>> & {
  label: string;
  textVariant?: RecipeVariants<typeof typographyRecipe>['variant'];
  textSize?: RecipeVariants<typeof typographyRecipe>['size'];
  textColor?: keyof typeof bgColorsVars;
  fontWeight?: RecipeVariants<typeof typographyRecipe>['fontWeight'];
}) => (
  <a target="_blank" rel="noreferrer" {...p}>
    <Typography
      variant={textVariant}
      size={textSize}
      color={textColor || 'B-100'}
      fontWeight={fontWeight || 'medium'}
      className={link}
    >
      {label}
    </Typography>
  </a>
);
